<template>
  <div class="h-full flex flex-col bg-white shadow-xl rounded-lg overflow-hidden mx-4 lg:ml-4 lg:mr-0">
    <!-- Logo -->
    <div class="px-6 py-4 flex flex-shrink-0 items-center justify-center border-b border-gray-100">
      <a href="/" class="block">
        <img src="@/assets/img/logo.png" class="h-12 w-auto object-contain" alt="Logo" />
      </a>
      <!-- Close button on mobile -->
      <button @click="$emit('close-sidebar')" class="lg:hidden absolute top-6 right-6 p-2 bg-gray-50 rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-200 transition-colors">
        <font-awesome-icon icon="times" class="h-5 w-5" />
      </button>
    </div>

    <!-- Navigation Links -->
    <nav class="flex-1 px-4 py-4 space-y-1.5 overflow-y-auto text-[0.85rem]">
      <router-link to="/private/dashboard" class="flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group" active-class="bg-gray-50 text-green-800 shadow-sm font-semibold">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform">
          <font-awesome-icon :icon="['fas', 'house']" class="text-sm" />
        </div>
        <span>{{ $t('menu.dashboard') }}</span>
      </router-link>

      <router-link to="/private/solicitudReuniones" class="flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group" active-class="bg-gray-50 text-green-800 shadow-sm font-semibold">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform">
          <font-awesome-icon :icon="['far', 'handshake']" class="text-sm" />
        </div>
        <span>{{ $t('menu.solicitar.reunion') }}</span>
      </router-link>

      <router-link to="/private/agenda" class="flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group" active-class="bg-gray-50 text-green-800 shadow-sm font-semibold">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform">
          <font-awesome-icon :icon="['far', 'calendar']" class="text-sm" />
        </div>
        <span>{{ $t('menu.agenda') }}</span>
      </router-link>

      <router-link to="/private/bloqueoHorario" class="flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group" active-class="bg-gray-50 text-green-800 shadow-sm font-semibold">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform">
          <font-awesome-icon :icon="['fas', 'ban']" class="text-sm" />
        </div>
        <span>{{ $t('menu.bloquear.horario') }}</span>
      </router-link>

      <router-link to="/private/mensajes" class="flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group" active-class="bg-gray-50 text-green-800 shadow-sm font-semibold">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform">
          <font-awesome-icon :icon="['far', 'fa-envelope']" class="text-sm" />
        </div>
        <span>{{ $t('menu.mensajes') }}</span>
      </router-link>

      <router-link to="/private/perfil" class="flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group" active-class="bg-gray-50 text-green-800 shadow-sm font-semibold">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform">
          <font-awesome-icon :icon="['far', 'user']" class="text-sm" />
        </div>
        <span>{{ $t('menu.mi.perfil') }}</span>
      </router-link>
    </nav>

    <!-- Footer Action -->
    <div class="flex-shrink-0 p-4 border-t border-gray-100">
      <button @click="logout" class="w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"> 
        <font-awesome-icon :icon="['fas', 'fa-arrow-right-from-bracket']" /> 
        {{ $t('menu.salir') }} 
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import seguridadServices from '@/services/seguridad.services';
import Swal from 'sweetalert2'

import configuracionMeetingService from '@/services/configuracion.merting.services';
import { ConfiguracionMeeting } from 'qreventos-suite/meeting';

export default defineComponent({
  methods: {
    async logout() {
      Swal.fire({
        title: this.$t('global.atencion'),
        html: this.$t('label.salir.sistema'),
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('boton.si.salir'),
        cancelButtonText: this.$t('boton.cancelar'),
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {  
          this.salir();
        }
      });
    },    
    salir() {
      const configuracionMeeting:ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
      seguridadServices.logout();
      this.$router.push({ path: '/' + configuracionMeeting.contextUrl });
      configuracionMeetingService.remove();
    }
  }  
});
</script>
